import { ApiErrorObject } from 'Douleutaras/types';
import { FieldErrors, UseFormSetError } from 'react-hook-form';

// Usage
// Input: parseV3ErrorsInline({ password: ['Wrong password'], required: ['This field is required'] })
// Output: 'Wrong password. This field is required.'
export const parseV3ErrorsInline = <T>(errorObject: FieldErrors<T>): string => {
  return Object.keys(errorObject)
    .map(key => errorObject[key])
    .join('. ');
};

export const parseV3Errors = <T>(errors: ApiErrorObject): FieldErrors<T> => {
  const errorObject = {};

  if (!errors) {
    return;
  }

  Object.keys(errors)
    .forEach(errorKey => {
      if (typeof errors[errorKey] === 'object' && !Array.isArray(errors[errorKey])) {
        Object.keys(errors[errorKey])
          .forEach(errorChildKey => {
            errorObject[`${errorKey}.${errorChildKey}`] = Array.isArray(errors[errorKey][errorChildKey])
              ? errors[errorKey][errorChildKey].join(', ') : errors[errorKey][errorChildKey];
          });
      } else {
        errorObject[errorKey] = Array.isArray(errors[errorKey])
          ? (errors[errorKey] as Array<string>).join(', ')
          : errors[errorKey];
      }
    });

  return errorObject;
};

// Normalizes and sets the error object coming from Douleutaras API v3, so it can be used in react hook forms
export default function apiV3ErrorProcessor<T>(errors: ApiErrorObject, setError: UseFormSetError<T>): void {
  const errorObject = parseV3Errors(errors);

  if (Object.keys(errorObject).length > 0) {
    Object.keys(errorObject)
      .forEach(errorKey => {
        return setError(
          // @ts-ignore
          errorKey,
          {
            type: 'server',
            message: errorObject[errorKey]
          }
        );
      });
  }

  return;
}

export const createGenericServerError = <T>(response: ApiErrorObject, setError: UseFormSetError<T>, t) => {
  if (!response || response.hasOwnProperty('errors')) {
    const message = Object.keys(response.errors)
      .map(errorKey => `${errorKey}: ${response.errors[errorKey]}`) || t('Unknown Error');
    setError('root.server', { type: 'server', message: `${t('Form submission error')}: ${message}` });
  }
};
